import { HookInfo, ICAFState } from "../types/caf";

export enum CAF_INITIALIZATION_SRC {
  GET_STARTED_BTN = 'get_started_clicked',
  OCCASSION_CATEGORY_BLOCK = 'page_embedded_occasion_source',
  AUTO = 'auto'
}

export enum ICON_MAPPINGS {
  WORK = 'WorkIcon',
  WEEKEND = 'WeekendIcon',
  EVENT = 'EventsIcon',
  DRESS = 'DressesIcon',
  TOP = 'TopsIcon',
  BOTTOM = 'BottomsIcon'
}

export const CATEGORIES_INITIAL_STATE: HookInfo = {
  sizeQuizInfo: null,
  isLoading: false,
  isError: false,
  isFetched: false
};

export const CAF_INIIAL_STATE: ICAFState = {
  conversations: [],
  isModalOpen: false,
  choosedOccasionCategory: '',
  allSelectedInfo: {},
  remainingSKUCategories: [],
  choosedSKUCategory: '',
  choosedBrand: ''
};

export enum RULE_NAMES_MAPPING {
  RULE_1 = 'initiate_conversation',
  RULE_2 = 'choose_sku_category_first_time',
  RULE_3 = 'choose_brand_first_time',
  RULE_4 = 'choose_size_first_time',
  RULE_5 = 'choose_sku_category_second_time',
  RULE_6 = 'choose_brand_second_time',
  RULE_7 = 'choose_size_second_time',
  RULE_8 = 'choose_brand_third_time',
  RULE_9 = 'choose_size_third_time',
  RULE_10 = 'flow_completed',
  RULE_11 = 'handle_button_click',
  RULE_12 = 'something_went_wrong'
}

export enum NODE_TYPES {
  TEXT = 'text',
  IMAGE_OPTIONS = 'imageOptions',
  BUBBLE_OPTIONS = 'bubbleOptions',
  BUTTON_OPTIONS = 'buttonOptions'
}

export enum CLOSE_CAF_METHOD {
  SWIPE = 'swipe',
  CROSS = 'cross'
}

export enum CATEGORY_NAMES_MAPPING {
  Dress = 'Dresses',
  Top = 'Tops',
  Pant = 'Bottoms',
  Work = 'Work',
  Weekend = 'Weekend',
  Events = 'Events'
}
/* eslint-disable quote-props */
export const PRE_RULES = {
  [RULE_NAMES_MAPPING.RULE_1]: {
    'name': RULE_NAMES_MAPPING.RULE_1,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'initiate_conversation_text',
        'dependentVariables': []
      },
      {
        'type': NODE_TYPES.IMAGE_OPTIONS,
        'selectedKeyName': 'choosedOccasionCategory',
        'value': [
          {
            'label': 'Work',
            'value': 'Work',
            'imageLink': 'WorkIcon'
          },
          {
            'label': 'Weekend',
            'value': 'Weekend',
            'imageLink': 'WeekendIcon'
          },
          {
            'label': 'Events',
            'value': 'Events',
            'imageLink': 'EventsIcon'
          }
        ],
        'dispatchAction': RULE_NAMES_MAPPING.RULE_2,
        'eventDetails': {
          'category': 'Conversation',
          'action': 'ClickLaunchQuestion',
          'label': 'selectedAnswer=%selectedAnswer%'
        },
        'virtualPage': 'Caf_Launch_Question'
      }
    ]
  },
  [RULE_NAMES_MAPPING.RULE_2]: {
    'name': RULE_NAMES_MAPPING.RULE_2,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_sku_category_first_time_text_1',
        'dependentVariables': []
      },
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_sku_category_first_time_text_2',
        'dependentVariables': []
      },
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_sku_category_first_time_text_3',
        'dependentVariables': []
      },
      {
        'type': NODE_TYPES.IMAGE_OPTIONS,
        'selectedKeyName': 'choosedSKUCategory',
        'requiredVars': ['remainingSKUCategories', 'choosedSKUCategory'],
        'isDynamic': true,
        'value': 'remainingSKUCategories',
        'dispatchAction': RULE_NAMES_MAPPING.RULE_3,
        'eventDetails': {
          'category': 'Category1',
          'action': 'ClickSizeQuizQuestion1',
          'label': 'selectedAnswer=%selectedAnswer%'
        },
        'virtualPage': 'Caf_Category_1'
      }
    ]
  },
  [RULE_NAMES_MAPPING.RULE_5]: {
    'name': RULE_NAMES_MAPPING.RULE_5,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_sku_category_second_time_text_1',
        'dependentVariables': []
      },
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_sku_category_second_time_text_2',
        'dependentVariables': []
      },
      {
        'type': NODE_TYPES.IMAGE_OPTIONS,
        'selectedKeyName': 'choosedSKUCategory',
        'isDynamic': true,
        'value': 'remainingSKUCategories',
        'dispatchAction': RULE_NAMES_MAPPING.RULE_6,
        'eventDetails': {
          'category': 'Category2',
          'action': 'ClickSizeQuizQuestion4',
          'label': 'selectedAnswer=%selectedAnswer%'
        },
        'virtualPage': 'Caf_Category_2'
      }
    ]
  },
  'choose_sku_category_third_time': {
    'name': 'choose_sku_category_third_time',
    'type': 'ref',
    'value': RULE_NAMES_MAPPING.RULE_8
  },
  [RULE_NAMES_MAPPING.RULE_3]: {
    'name': RULE_NAMES_MAPPING.RULE_3,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_brand_first_time_text_1',
        'dependentVariables': ['choosedSKUCategory']
      },
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_brand_first_time_text_2',
        'dependentVariables': []
      },
      {
        'type': NODE_TYPES.BUBBLE_OPTIONS,
        'isDynamic': true,
        'selectedKeyName': 'choosedBrand',
        'value': 'skuCategoryBasedBrands',
        'dispatchAction': RULE_NAMES_MAPPING.RULE_4,
        'eventDetails': {
          'category': 'Brand1',
          'action': 'ClickSizeQuizQuestion2',
          'label': 'selectedAnswer=%selectedAnswer%, selectedCategory=%selectedCategory%'
        },
        'virtualPage': 'Caf_Brand_1'
      }
    ]
  },
  [RULE_NAMES_MAPPING.RULE_6]: {
    'name': RULE_NAMES_MAPPING.RULE_6,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_brand_second_time_text',
        'dependentVariables': ['choosedSKUCategory']
      },
      {
        'type': NODE_TYPES.BUBBLE_OPTIONS,
        'isDynamic': true,
        'selectedKeyName': 'choosedBrand',
        'value': 'skuCategoryBasedBrands',
        'dispatchAction': RULE_NAMES_MAPPING.RULE_7,
        'eventDetails': {
          'category': 'Brand2',
          'action': 'ClickSizeQuizQuestion5',
          'label': 'selectedAnswer=%selectedAnswer%, selectedCategory=%selectedCategory%'
        },
        'virtualPage': 'Caf_Brand_2'
      }
    ]
  },
  [RULE_NAMES_MAPPING.RULE_8]: {
    'name': RULE_NAMES_MAPPING.RULE_8,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_brand_third_time_text',
        'dependentVariables': ['choosedSKUCategory']
      },
      {
        'type': NODE_TYPES.BUBBLE_OPTIONS,
        'isDynamic': true,
        'value': 'skuCategoryBasedBrands',
        'selectedKeyName': 'choosedBrand',
        'dispatchAction': RULE_NAMES_MAPPING.RULE_9,
        'eventDetails': {
          'category': 'Brand3',
          'action': 'ClickSizeQuizQuestion7',
          'label': 'selectedAnswer=%selectedAnswer%, selectedCategory=%selectedCategory%'
        },
        'virtualPage': 'Caf_Brand_3'
      }
    ]
  },
  [RULE_NAMES_MAPPING.RULE_4]: {
    'name': RULE_NAMES_MAPPING.RULE_4,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_size_first_time_text_1',
        'dependentVariables': ['choosedSKUCategory', 'choosedBrand']
      },
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_size_first_time_text_2',
        'dependentVariables': []
      },
      {
        'type': NODE_TYPES.BUBBLE_OPTIONS,
        'isDynamic': true,
        'selectedKeyName': 'choosedSize',
        'value': 'skuCategoryBasedBrandsBasedSizes',
        'dispatchAction': RULE_NAMES_MAPPING.RULE_5,
        'eventDetails': {
          'category': 'Size1',
          'action': 'ClickSizeQuizQuestion3',
          'label': 'selectedAnswer=%selectedAnswer%, selectedCategory=%selectedCategory%, selectedBrand=%selectedBrand%'
        },
        'virtualPage': 'Caf_Size_1'
      }
    ]
  },
  [RULE_NAMES_MAPPING.RULE_7]: {
    'name': RULE_NAMES_MAPPING.RULE_7,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_size_second_time_text',
        'dependentVariables': ['choosedSKUCategory', 'choosedBrand']
      },
      {
        'type': NODE_TYPES.BUBBLE_OPTIONS,
        'isDynamic': true,
        'selectedKeyName': 'choosedSize',
        'value': 'skuCategoryBasedBrandsBasedSizes',
        'dispatchAction': RULE_NAMES_MAPPING.RULE_8,
        'eventDetails': {
          'category': 'Size2',
          'action': 'ClickSizeQuizQuestion6',
          'label': 'selectedAnswer=%selectedAnswer%, selectedCategory=%selectedCategory%, selectedBrand=%selectedBrand%'
        },
        'virtualPage': 'Caf_Size_2'
      }
    ]
  },
  [RULE_NAMES_MAPPING.RULE_9]: {
    'name': RULE_NAMES_MAPPING.RULE_9,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'choose_size_third_time_text',
        'dependentVariables': ['choosedSKUCategory', 'choosedBrand']
      },
      {
        'type': NODE_TYPES.BUBBLE_OPTIONS,
        'isDynamic': true,
        'selectedKeyName': 'choosedSize',
        'value': 'skuCategoryBasedBrandsBasedSizes',
        'dispatchAction': RULE_NAMES_MAPPING.RULE_10,
        'eventDetails': {
          'category': 'Size3',
          'action': 'ClickSizeQuizQuestion8',
          'label': 'selectedAnswer=%selectedAnswer%, selectedCategory=%selectedCategory%, selectedBrand=%selectedBrand%'
        },
        'virtualPage': 'Caf_Size_3'
      }
    ]
  },
  [RULE_NAMES_MAPPING.RULE_10]: {
    'name': RULE_NAMES_MAPPING.RULE_10,
    'response': [
      {
        'type': NODE_TYPES.TEXT,
        'value': 'render_next_button',
        'dependentVariables': []
      },
      {
        'type': NODE_TYPES.BUTTON_OPTIONS,
        'isDynamic': false,
        'className': 'base-button--primary sj-button sj-base-button',
        'selectedKeyName': '',
        'value': 'Next',
        'dispatchAction': RULE_NAMES_MAPPING.RULE_11,
        'eventDetails': {
          'category': 'NextButtonClick',
          'action': 'ClickCompleteConversation',
          'label': ''
        },
        'virtualPage': ''
      }
    ]
  }
};
